import client from '../plugins/client';

export default {
  getCities() {
    return client.get('/city/basic');
  },

  /**
   * @param {string} name city name
   */
  searchCities(name) {
    return client.get('/cities/search', { params: { name } });
  },
};
